import { http } from "./client";

export const fetchReportCatalog = () => http.get("Reports");

export const runReport = ({ reportId, parameters }) => {
    return http.post(`Reports/${reportId}/run`, { parameters });
};
